<template>
    <div class="news_select_wrap">
        <div style="position: absolute;right: 0px;top: 15%;">
          <input id="search_str" v-model="search_str" type="text" name="search_str" placeholder="搜尋新聞標題" v-on:keyup.enter="search_news()" class="form-control searchBar_border">
          <div id="search-btn" class="search-btn" @click="search_news()"></div>
        </div>
        <div class="custom_select_word" style="left: initial;right:380px;">分類</div>
        <div class="col-md-12 custom-select" style="margin-right: 220px;">
            <select v-model="selected" :data-model="name">
                <option :value="odr.value" v-for="(odr, idx) of order" :key="idx">{{odr.name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus, newsOrder, sourceTree} from './config.js'
import user from './user.js'
import select from './libs/jquery.select.js'

export default {
  name: 'DropdownOrder',
  props: ["name", "order"],
  data () {
    return {
      search_str: "",
      selected: sourceTree.register.newsOrdering,
    }
  },
  methods: {
    ...user,
    search_news() {
      this.$root.getNewsListByType($(".newsListItem .custom-select>select").val(), 1, $("#search_str").val());
    }
  },
  computed: {
    bookType: function () {
        let keys = Object.keys(this.$root.bookType)
        this.$root.removeItemFromArray(keys,'index')
        this.$root.removeItemFromArray(keys,'novel')
        // console.log(keys)
        return keys
    },
    pageKey: function () {
        let keys = Object.keys(this.$root.bookType)
        let locate
        keys.map(key => {
            if (this.$root.bookType[key].id == this.id) locate = key
        })
        return locate
    }
  },
  mounted () {
    // console.log('Subscribe mounted')
    // console.log(this.$el.querySelector(".custom-select"))
    let dropdown = this.$el.querySelector(".custom-select")
    select.bindOneDropdown.bind(this)(dropdown)
    // this.bindSelect()
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>



// WEBPACK FOOTER //
// src/DropdownOrder.vue